import { api } from "../api";
import { QuestionnaireTemplate } from "../../model/templates/QuestionnaireTemplate";
import { parseQuestionnaireTemplate } from "../../parsers/template/parseQuestionnaireTemplate";

export const getQuestionnaireTemplates = async (): Promise<QuestionnaireTemplate[]> => {
  const result = await api.services.questionnaireTemplates.getAllQuestionnaireTemplates();
  return result.data.map(parseQuestionnaireTemplate).sort((a, b) => a.title.localeCompare(b.title));
};
